import React, { useState } from "react";

import PublicTable from "components/PublicTable";
import PublicFilter from "components/PublicFilter";
import TermsRefresh from "views/TermsRefresh";
import InstallBanner from "components/InstallBanner";

const Documents = (params) => {
  const notificationReference = React.useRef(null);

  const [isBusy, setIsBusy] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [documentsData, setDocumentsData] = useState({
    data: [],
    totalSize: 0,
  });

  React.useEffect(() => {
    // console.log('Documents-React.useEffect-layouts: ', params?.match?.params?.layouts);
    let filter = getFilter(params?.match?.params?.layouts);
    setFilterData(filter);
  }, [params?.match?.params?.layouts]);
  const getFilter = (layouts) => {
    if (!layouts) return null;

    return {
      layoutCodes: layouts,
    };
  };

  return (
    <React.Fragment>
      <TermsRefresh {...params} />
      <InstallBanner />
      <main className="main text-center">
        <PublicFilter
          {...params}
          simple
          data={filterData}
          setData={setFilterData}
          setDocumentsData={setDocumentsData}
          isBusy={isBusy}
          setIsBusy={setIsBusy}
          alertRef={notificationReference}
        />
        <PublicTable
          filterData={filterData}
          setFilterData={setFilterData}
          documentsData={documentsData}
        />
      </main>
    </React.Fragment>
  );
};
export default Documents;
